import type { ReminderExtension } from '@/components/reminders/extensions/extension-types';
import { SolutionOutlined } from '@ant-design/icons';

export const jobReminderExtension: ReminderExtension = {
  moduleId: 'job-module',
  buildContext: ({ moduleData }) => {
    if (!moduleData || typeof moduleData !== 'object') return undefined;
    return {
      source: 'job-module',
      ...(moduleData as Record<string, unknown>)
    };
  },
  getReminderIcon: () => <SolutionOutlined />
};
